import { useEffect } from "react"
import { useRouteError } from "react-router"
import { logger } from "@/shared/utils/add/logger/logger"
import { ErrorBoundaryContent } from "../../errorBoundaryContent/ErrorBoundaryContent"

export function RouterErrorBoundary() {
  const error = useRouteError() as Error
  useEffect(() => {
    logger.error("Error in RouterErrorBoundary", error)
  }, [error])
  return <ErrorBoundaryContent error={error} />
}
